import './App.css';
import { useEffect, useState, useCallback } from 'react'
import {
  Button,
  Row,
  Col,
  Container,
  Image,
  Text,
  // @ts-ignore
} from 'atomize';
import { Description } from './Description';
import { contractId } from './contractId'
import { WrongNetworkModal } from './modals/WrongNetworkModal';
import { TransactionSubmittedModal } from './modals/TransactionSubmittedModal';
import { Link } from 'react-router-dom'
import { SimpleConnect } from './components/SimpleConnect'
// @ts-ignore
import Banner from 'react-js-banner';

// @ts-ignore
const ethers = require('ethers')
const contractABI = require('./MoreOrLessVote.json').abi

function Home() {

  // @ts-ignore
  const [account, setAccount] = useState('')
  const [svg, setSVG] = useState('')
  const [highVotes, setHighVotes] = useState(0)
  const [lowVotes, setLowVotes] = useState(0)
  const [latestMint, setLatestMint] = useState(0)
  const [latestName, setLatestName] = useState('')
  const [latestVote, setLatestVote] = useState('')
  const [latestVoter, setLatestVoter] = useState('')
  const [showSampleVideo, setShowSampleVideo] = useState(true)
  const [alreadyVoted, setAlreadyVoted] = useState(false)
  const [outOfSupply, setOutOfSupply] = useState(false)
  const [wrongNetworkModal, setWrongNetworkModal] = useState(false)
  const [transactionModal, setTransactionModal] = useState(false)
  const [transactionId, setTransactionId] = useState('')
  let provider: any
  // @ts-ignore
  if (window.ethereum) {
    // @ts-ignore
    provider = new ethers.providers.Web3Provider(window.ethereum, 'mainnet')
  }

  const onProviderChange = (newNetwork: any, oldNetwork: any) => {
    console.log('new', newNetwork)
    console.log('old', oldNetwork)
    // if (newNetwork.chainId !== 4) {
    //   setWrongNetworkModal(true)
    // } else {
    //   setWrongNetworkModal(false)
    // }
      // When a Provider makes its initial connection, it emits a "network"
      // event with a null oldNetwork along with the newNetwork. So, if the
      // oldNetwork exists, it represents a changing network
    // if (oldNetwork) {
    //   window.location.reload();
    // }
  }

  provider?.on("network", onProviderChange);

  const svgHead = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="moreorless" width="1000" height="1000" viewBox="0 0 1000 1000">`
  const svgBottom = `</svg>`

  const connect = useCallback(async () => {

    if (provider) {
      console.log('Ethereum successfully detected!')

      console.log(account)
      if (account) {
        try {
          const moreOrLessContract = new ethers.Contract(contractId, contractABI, provider);
          
          const votesByAccount = await moreOrLessContract.balanceOf(account)
          setAlreadyVoted(ethers.BigNumber.from(votesByAccount).toNumber() === 1)

          const { chainId } = await provider.getNetwork()
    
          console.log(chainId)
          switch (chainId) {
            case 1:
              break
            case 4:
            default:
              setWrongNetworkModal(true)
          }
        } catch (e) {
          console.log(e)
          return
        }
      }
    } else {
      // if the provider is not detected, detectEthereumProvider resolves to null
    }
  // eslint-disable-next-line
  }, [account])

  const getVotes = useCallback(async () => {
    const moreOrLessContract = new ethers.Contract(contractId, contractABI, provider);

    const moreVotes = await moreOrLessContract.moreVotes()
    const lessVotes = await moreOrLessContract.lessVotes()
    setHighVotes(ethers.BigNumber.from(moreVotes).toNumber())
    setLowVotes(ethers.BigNumber.from(lessVotes).toNumber())
// eslint-disable-next-line
}, [])

  useEffect(() => {

    const wrapper = async () => {

      // @ts-ignore
      if (!window?.ethereum) {
        return
      }
      // @ts-ignore
      await window.ethereum?.enable()

      const baseSVG = `${svgHead}${svgBottom}`

      setSVG(baseSVG)
  
      let moreOrLessContract
      let supply = 0
      try {
        moreOrLessContract = new ethers.Contract(contractId, contractABI, provider);
        supply = await moreOrLessContract.totalSupply()
        if (ethers.BigNumber.from(supply).toNumber() >= 1000) {
          setOutOfSupply(true)
        }
      } catch (e) {
        if (e.message.includes('underlying network changed')) {
          setWrongNetworkModal(true)
        }
        console.log(e)
        return
      }

      console.log(`Supply: ${supply}`)
      if (ethers.BigNumber.from(supply).toNumber() === 0) {
        setShowSampleVideo(true)
      } else {
        setShowSampleVideo(false)
        setLatestMint(ethers.BigNumber.from(supply).toNumber() - 1)
        const svg = await moreOrLessContract.tokenURI(ethers.BigNumber.from(supply).toNumber() - 1)
        console.log(svg.substring(27,))
        const meta = JSON.parse(svg.substring(27,))
        setSVG(meta.image)
        setLatestName(meta.name)
        setLatestVote(meta['attributes'].find((attribute: any) => attribute.trait_type === 'Token Vote')?.value)
        setLatestVoter(meta['attributes'].find((attribute: any) => attribute.trait_type === 'Voted By')?.value)
        await getVotes()
        await connect()
      }
    }

    wrapper()
  // eslint-disable-next-line
  }, [connect, getVotes, svgBottom, svgHead])

  const callback = async (purchase: any) => {

    console.log(purchase)
    
    setTransactionId(purchase.hash)
    setTransactionModal(true)

    purchase.wait(3).then(async (receipt: any) => {
      const signer = provider.getSigner()

      const moreOrLessContract = new ethers.Contract(contractId, contractABI, signer)
  
      // @ts-ignore
      const supply = await moreOrLessContract.totalSupply()
      if (ethers.BigNumber.from(supply).toNumber() >= 1000) {
        setOutOfSupply(true)
      }
      // @ts-ignore
      const svg = await moreOrLessContract.tokenURI(ethers.BigNumber.from(supply).toNumber() - 1)
      console.log(svg.substring(27,))
      const meta = JSON.parse(svg.substring(27,))
      setSVG(meta.image)
      setLatestName(meta.name)
      setLatestVote(meta['attributes'].find((attribute: any) => attribute.trait_type === 'Token Vote')?.value)
      setLatestVoter(meta['attributes'].find((attribute: any) => attribute.trait_type === 'Voted By')?.value)
      setLatestMint(ethers.BigNumber.from(supply).toNumber() - 1)
      setAlreadyVoted(true)
      getVotes()

      setTransactionModal(false)
    
      return receipt;
    })
  }

  const catchFunc = (e: any) => {
    console.log(e)
  }

  const mint = async (high: boolean) => {
    const signer = provider.getSigner()

    const moreOrLessContract = new ethers.Contract(contractId, contractABI, signer)

    let gasEstimate
    try {
      if (high) {
        gasEstimate = await moreOrLessContract.estimateGas.mintMORE({
          from: signer.address,
          value: ethers.BigNumber.from(1000000000)
        })
      } else {
        gasEstimate = await moreOrLessContract.estimateGas.mintLESS({
          from: signer.address,
          value: ethers.BigNumber.from(100000000)
        })
      }
    } catch (e) {
      console.log(e)
      if (e.message.includes('vote twice')) {
        setAlreadyVoted(true)
        return

      } else if (e.message.includes('cannot estimate gas')) {
        gasEstimate = 3000000
      }
    }

    console.log(`gas`, gasEstimate)

    try {
      if (high) {
        moreOrLessContract.mintMORE({
          from: signer.address,
          value: ethers.utils.parseEther("0.1"),
          gasLimit: ethers.BigNumber.from(gasEstimate).mul(130).div(100)
        }).then(callback).catch(catchFunc);
      } else {
        moreOrLessContract.mintLESS({
          from: signer.address,
          value: ethers.utils.parseEther("0.01"),
          gasLimit: ethers.BigNumber.from(gasEstimate).mul(130).div(100)
        }).then(callback).catch(catchFunc);
      }
    } catch (e: any) {
      console.log(e)
    }
  }

  const buildTweet = () => {
    const sentence = `I just voted "${latestVote}" in the more or less social experiment. See my mint here - https://moreorless.eth.link/#/yourvote?address=${account}`
    return `https://twitter.com/intent/tweet?text=${encodeURIComponent(sentence)}`
  }

  return (
    <Container className="App" fontFamily="code">
      { alreadyVoted &&
        <Banner 
          title={'You have already voted.'}
          css={{background: 'red'}}
        />}
      { outOfSupply &&
        <Banner 
          title={'No more votes left.'}
          css={{background: 'red'}}
        />}
      <Row p="2rem">
      {wrongNetworkModal && WrongNetworkModal()}
      {transactionModal && TransactionSubmittedModal(setTransactionModal, transactionId)}
          <Col>
            <SimpleConnect setWrongNetworkModal={setWrongNetworkModal} setAccount={setAccount} />
          </Col>
          <Link to={`/playground`} target='_blank'>
            <Button bg='medium' m={{r:"2rem"}}>
                Go to Playground
            </Button>
          </Link>
          <Link to={`/yourvote?address=${account}`} target='_blank'>
            <Button bg='medium' disabled={!alreadyVoted}>
                See Your Vote
            </Button>
          </Link>
      </Row>
      <Row height="100px" width="100px">
        <Col>
          <Description />
          { !alreadyVoted && <Row m={{t: '2rem'}}>
            <Button m={{ l: "8rem" }} onClick={() => mint(true)} bg='medium' disabled={alreadyVoted || outOfSupply || !account}>Vote 0.1 ETH</Button>
            <Button m={{ l: "8rem" }} onClick={() => mint(false)} bg='medium' disabled={alreadyVoted || outOfSupply || !account}>Vote 0.01 ETH</Button>
          </Row> }
          { alreadyVoted && <Row m={{t: '2rem'}}>
            <Text m={{ l: "8rem" }}>{highVotes} "MORE" Votes</Text>
            <Text m={{ l: "9rem" }}>{lowVotes} "LOW" Votes</Text>
          </Row> }
          { alreadyVoted && <Row>
            <Text m={{ l: "10rem", b: "5rem" }}>{lowVotes > highVotes ? `Donating ${lowVotes * 0.01} ETH and keeping ${highVotes * 0.1} ETH` : `Donating ${highVotes * 0.1} ETH and keeping ${lowVotes * 0.01} ETH`}</Text>
          </Row> }
        </Col>
        <Col height="100px" width="100px">
          { showSampleVideo ? (
            <video src={`example_mints.mp4`} autoPlay muted loop width="300px" height="300px"/>
          ) : (
            <Image src={`${svg}`} alt="Current state" width="300px" height="300px" style={{width: '300px', height: '300px'}} />
          )}
          <Text>{showSampleVideo ? 'Example Mints' : latestName}</Text>
          { !showSampleVideo && <Text>Voted "{latestVote}" by {latestVoter?.substring(0,5)}...{latestVoter?.substring(37,)}</Text>}
            { !showSampleVideo && <Text><a target='_blank' rel='noreferrer' href={`https://opensea.io/assets/${contractId}/${latestMint}`} >View on OpenSea</a></Text>}
            { !showSampleVideo && <Text><a target='_blank' rel='noreferrer' href={buildTweet()} >Share on Twitter</a></Text>}
        </Col>

      </Row>
    </Container>
  );
}

export default Home;
